import {callURL} from './call';
import messageShow from "./messageShow";
import {UPDATE_DATA} from "../types";
import {signerURL} from "../url";
import logout from "./logout";

const getWorkflowDetailsInformation= (formValues,callbackError) => async (dispatch) =>
{
    dispatch({type:UPDATE_DATA,payload:{workflowDetails:{pendingSigners:[],finishedSigners:[]}}});
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            const filesInfo=result[1].filesInfo;
            if(filesInfo)
                dispatch({type:UPDATE_DATA,payload:{workflowDetails:filesInfo}});
        }
        else
        {
            callbackError();
            if(result && result[1] && result[1].code===440)
                dispatch(logout());
            else
                dispatch(messageShow({message: result[1].detail, type: 'error'}));
        }

    }
    dispatch(callURL(signerURL,"rest/UserService/getWorkflowDetailsInformation",formValues,onResult));
};
export default getWorkflowDetailsInformation;